import {z} from "zod/v4-mini"
import {graphNode} from "@cm/graph-v3"
import {registerTemplateGraphNode} from "#template/template-node/register"
import {meshGeometryAttributeLikeMarker} from "#template/nodes/geometry-graph/attribute/attribute-node"
import {MeshGeometryGrid2} from "#template/nodes/geometry-graph/attribute/primitive/mesh-geometry-grid-2"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {MeshGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {PrimitiveParameters} from "#template/nodes/geometry-graph/attribute/primitive/geometry-primitive-node"
import {GeometryPrimitiveNode} from "#template/nodes/geometry-graph/attribute/primitive/geometry-primitive-node"

export type MeshGeometryPrimitiveParameters = PrimitiveParameters<MeshGeometryGrid2>

const definition: TemplateNodeDefinition<MeshGeometryPrimitiveParameters> = {
    nodeClass: "MeshGeometryPrimitive",
    validation: {
        parameters: z.object({
            name: z.string(),
            primitive: graphNode(MeshGeometryGrid2),
        }),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class MeshGeometryPrimitive extends GeometryPrimitiveNode<2, MeshGeometryGrid2> implements MeshGeometryAttributeLikeNode {
    get [meshGeometryAttributeLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
